

































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import "swiper/css/swiper.css";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
@Component({
  components: {
    Swiper,
    SwiperSlide
  }
})
export default class SwiperCase extends Vue {
  @Prop({ default: 1 })
  type;
  @Prop()
  list!: any[];
  @Prop()
  jump;
  SwiperCase = {
    slidesPerView: 3,
    observer: true,
    observeParents: true,
    spaceBetween: 90,
    loop: this.list.length > 2 ? true : false,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false
    },
    breakpointsInverse: true,

    preventClicksPropagation: true,
    speed: 600,
    breakpoints: {
      //当宽度大于等于320
      320: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      //当宽度大于等于480
      480: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      //当宽度大于等于640
      640: {
        slidesPerView: 2,
        spaceBetween: 30
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 30
      },
      1000: {
        slidesPerView: 3,
        spaceBetween: 50
      },
      1366: {
        slidesPerView: 3,
        spaceBetween: 90
      }
    }
  };

  mounted() {
    // console.log("this.list", this.list);
  }
}
